import {
    CHANGE_AUTH,
    REST_API,
    EYM_TKN,
    EYM_TKN_OBJ,
    EYM_USR,
    REACT_APP_EMAIL,
    REACT_APP_TEMP
} from './constants'

const encodeQuery = function(param) {

  let data = btoa(param);
  let part1 = data.substr(0, 25);
  let part2 = data.substr(25);

  let reverse = part2 + part1

  let final = btoa(reverse);

  return final    
}

export function changeAuth(auth){
    return {
        type: CHANGE_AUTH,
        auth
    }
}

export function login(data)
{
    return dispatch => {
        return fetch(`${REST_API}/users/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(response => {
        
            let json = response.json().then(json => {
                let lstg = window.localStorage
                let sstg = window.sessionStorage
                if( json.id ) {
                    if(data.rememberme) {
                        lstg.setItem( EYM_TKN, json.id )
                        lstg.setItem( EYM_TKN_OBJ, JSON.stringify(json) )
                    } else {
                        sstg.setItem( EYM_TKN, json.id )
                        sstg.setItem( EYM_TKN_OBJ, JSON.stringify(json) )
                    }

                    dispatch(getUserData(json.userId, json.id, data.rememberme))
                } else {
                    dispatch(changeAuth({
                        error: 'Invalid Username or Password'
                    }))
                }

                return json
            })

            return {
                response: response,
                json: json
            }
        })
    }
}

export function logout(token)
{
    let lstg = window.localStorage
    lstg.removeItem( EYM_TKN )   

    return dispatch => {
        return fetch(`${REST_API}/users/logout?access_token=${token}`,{
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            }           
        }).then( response => {
            dispatch(changeAuth({
                access_token: null,
                authenticated: false, 
                error: null
            }))

            return {
                response: response,
                json: null // logout does not have a json body
            }
        })
    }
}

export function forgotPassword(data,category,url){
    
    return dispatch => {

        // return fetch(`${REST_API}/users/login`, {
        //     method: 'POST',
        //     headers: {
        //         'Content-Type': 'application/json'
        //     },
        //     body: JSON.stringify({email:REACT_APP_EMAIL,password:REACT_APP_TEMP})
        // })
        // .then(res=> {
        //     return res.json()
        // })
        // .then(json => {
        //     return fetch(`${REST_API}/Users/forgot-password?acces_token=${json.id}&email=${data}&url=${url}`, {
        //         method: 'GET',
        //         headers: {
        //             'Content-Type': 'application/json'
        //         }
        //     }).then(response => {
        //         console.log('LAST',response)
        //         return {
        //             response: response
        //         }
        //     })
        //     .then(res => {
        //         console.log('VNCXVXCVXCV',res.response)
        //         return res.response
        //     })
        // })
        return fetch(`${REST_API}/Users/forgot-password?email=${data}&url=${url}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {
            return response
        })
        
    }
    
}

async function fakeLogin(){
    let result = fetch(`${REST_API}/users/login`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({email:REACT_APP_EMAIL,password:REACT_APP_TEMP})
        })
        .then( res =>{
            return res.json()
        })
        .then(json => {
            return json
        })

    return result
}   

export function newUser(acces_token,email, username, password, url){

    var data = {
        email: email,
        username:username,
        password: password,
        url: url
    }
    return dispatch => {
        return fetch(`${REST_API}/Users/send-email?access_token=${acces_token}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        }).then(response => {

            return {
                response: response
            }
        })
    }
}

export function verifyCode(email,code){
    return dispatch => {
        return fetch(`${REST_API}/Users/verify-code?email=${email}&code=${code}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {

            return {
                response: response
            }
        })
    }
}

export function resetPassword(password, id){
    return dispatch => {
        return fetch(`${REST_API}/Users/reset-password?password=${password}&id=${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(response => {

            return {
                response: response
            }
        })
    }
}

export function getUserData(userId, access_token, rememberMe){
    return dispatch => {
        return new Promise((resolve)=>{
            let user = null
        
            // Get auth user info
            fetch(`${REST_API}/users/${userId}?access_token=${access_token}`).then(userResponse=>{
                if(userResponse.ok){
                    userResponse.json().then(userInfo=>{
                        user = userInfo
                        let roleFilter = encodeQuery(JSON.stringify({where:{principalId:`${user.id}`}}) )
                        fetch(`${REST_API}/RoleMappings?filter=${roleFilter}&access_token=${access_token}`)
                        .then(roleMapResponse => {
                           
                            if(roleMapResponse.ok){
                                roleMapResponse.json().then(roles=>{
                                    let lstg = window.localStorage
                                    let sstg = window.sessionStorage
                                    user.roles = Array.isArray(roles) ? roles : [roles]

                                    let isAdmin = false
                                    if(Array.isArray(roles)){
                                        isAdmin = (roles.find(role=>role.roleId===1) !== undefined) || (roles.find(role=>role.roleId===33) !== undefined)
                                    } else if ( typeof roles === "object" ){
                                        isAdmin = roles.roleId && (roles.roleId === 1 || roles.roleId===33)
                                    }

                                    user.isAdmin = isAdmin
                                    
                                    if(rememberMe)
                                        lstg.setItem( EYM_USR, JSON.stringify(user) )
                                    else
                                        sstg.setItem( EYM_USR, JSON.stringify(user) )
    
                                    resolve(dispatch(changeAuth({
                                        access_token: access_token,
                                        authenticated: true,
                                        error: null,
                                        user: user
                                    })))
                                })
                            } else {
                                resolve(dispatch(changeAuth({
                                    error: 'Error retrieving user roles'
                                })))
                            }
                        })
                    })
                } else {
                    resolve(dispatch(changeAuth({
                        error: 'Error retrieving user info'
                    })))
                }
            })
        })
    }
}


/**
 * Reset a user Password
 */

export const resetUserPassword = () => async dispatch => {
    const token = window.localStorage.getItem(`${EYM_TKN}`)
    const response = await fetch(`${REST_API}/users/reset?access_token=${token}`)
    .then(res => res.json())
    .then( data  => {
        // REST PASSWORD LOGIC HERE
    })

    dispatch({
        type: "RESET_PASSWORD",
        payload: response.ok
    })
}


// WEBPACK FOOTER //
// ./src/actions/auth.js